import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import {
  ContributionsTableComponent,
  DIALOG_DATA,
  DIALOG_REF,
} from '@ansys-internal/awf-angular/shared';
import {
  AWCTableColumns,
  AWCTableRow,
  TableCellAlign,
} from '@ansys-internal/awc-angular/tables';
import { IconComponent, Icons } from '@ansys-internal/awc-angular/icons';
import { ActionContributionsService } from '@ansys-internal/awf-angular/contributions';
import { RequirementsService } from '../../../shared/services/requirements.service';
import { AWCFilter } from '@ansys-internal/awc-angular/filters';
import { State } from '@ansys-internal/awf-angular/store';
import { SelectedDriveCycleState } from '../../../state/lib/selected-drive-cycle.state';
import { EventBus } from '../../../shared/tools/event-bus';
import { UpdateInputs } from '../../../actions';
import {
  DataDisplayService,
  DataDisplayState,
} from '../../../shared/services/data-display.service';
import { ContributionsEnum } from '../../../awf-contributions/contributions.enum';
import { SelectionService } from '../../../shared/services/selection.service';
import { ButtonComponent } from '@ansys-internal/awc-angular/buttons';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    selector: 'app-import-drive-cycle',
    templateUrl: './import-drive-cycle.component.html',
    styleUrl: './import-drive-cycle.component.scss',
    imports: [
        IconComponent,
        ContributionsTableComponent,
        ButtonComponent,
        SharedModule,
    ]
})
export class ImportDriveCycleComponent {
  @ViewChild('fileUpload') upload!: ElementRef;
  protected driveCycles: AWCTableRow[] = [];
  protected columns: AWCTableColumns[] = [
    {
      id: 'name',
      header: 'Name',
      sortable: true,
      align: TableCellAlign.LEFT,
    },
    {
      id: 'menu',
      header: '',
    },
  ];
  protected driveCyclesLoaded: boolean = false;
  protected readonly icons = Icons;
  protected filters: AWCFilter[] = [];
  protected readonly contributionsEnum = ContributionsEnum;
  private bus: EventBus = EventBus.getInstance();
  private updatingSelection: boolean = false;

  constructor(
    @Inject(DIALOG_DATA)
    private data: {
      selectedDriveCycle: string;
      part: any;
      onUpdate: () => void;
    },
    @Inject(DIALOG_REF) private dialogRef: any,
    private action: ActionContributionsService,
    private requirementService: RequirementsService,
    private state: State,
    private actionService: ActionContributionsService,
    private displayService: DataDisplayService,
    private cdr: ChangeDetectorRef,
    private sectionService: SelectionService
  ) {
    this.driveCyclesLoaded = true;

    this.bus.register('input:update:complete', () => {
      this.updatingSelection = false;
    });
  }

  ngOnInit(): void {
    this.state.set(SelectedDriveCycleState, this.data.selectedDriveCycle);
  }

  ngOnDestroy(): void {
    this.state.set(SelectedDriveCycleState, '');
  }

  protected uploadClick(): void {
    this.upload.nativeElement.value = '';
  }

  protected addDriveCycle($event: Event): void {
    this.upload.nativeElement.click();
  }

  protected async importDriveCycle($event: Event): Promise<void> {
    this.driveCyclesLoaded = false;
    const input = $event.target as HTMLInputElement;
    if (!input?.files?.length) return;

    const file: File = input.files[0];

    if (file) {
      try {
        const driveCycle = await this.requirementService.addDriveCycleFromFile(
          file.name.split('.')[0],
          file
        );

        if (driveCycle.id) {
          this.selectionIDSet(driveCycle.id);
        }
      } catch (e) {
        this.cdr.markForCheck();
      }
    }
    this.driveCyclesLoaded = true;
  }

  protected async selectionIDSet(driveCycleId: string): Promise<void> {
    if (this.updatingSelection) {
      return;
    }
    this.displayService.displayState = DataDisplayState.LOADING;
    this.updatingSelection = true;
    this.state.set(SelectedDriveCycleState, driveCycleId);
    this.data.part['drive_cycle_id'] = driveCycleId;
    this.data.selectedDriveCycle = driveCycleId;
    this.actionService.execute(UpdateInputs);
    this.bus.dispatch('drive-cycle:select:update', driveCycleId);
    this.data.onUpdate();
    this.sectionService.sectionSelectionChanged.next(
      this.sectionService.sectionSelectionChanged.value
    );
    this.dialogRef.close();
  }
}
